import React, { useState } from 'react';
import { useForm } from '../../molecules/Form';
import Form from '../../molecules/Form/Form';
import Field from '../Field';
import Button from '../../molecules/Button';
import { AddDeviceModalWrapper } from './AddDeviceModal.style';
import { useEffect } from 'react';
import deviceService from '../../../services/deviceService';
import Toast from '../../molecules/Toast';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import DefaultConfigurations from '../../../helpers/schema-tms-config.json';
import { getCookie } from '../../../helpers/common';

const AddDeviceModal = ({ onSubmit, onClose, isEdit, data }) => {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);

  const { refetch, user } = useContextHook(AuthContext, v => ({
    refetch: v.refetch,
    user: v.user,
  }));
  async function handelSubmit(e) {
    setLoading(true);
    if (isEdit) {
      const payload = {
        title: e?.deviceName,
        tid: data?.serialNumber,
        serial_number: data?.serialNumber,
        store_id: data?.store_id?._id,
        business_id: data?.store_id?.business_id,
      };
      try {
        await deviceService.editDevice(data?._id, payload);
        Toast({
          message: 'Device Updated Successfully',
          type: 'success',
        });
        refetch();
        onSubmit();
      } catch (error) {
        Toast({
          type: 'error',
          message: error?.message,
        });
      } finally {
        setLoading(false);
      }
    } else {
      const payload = {
        title: e?.deviceName,
        tid: e?.serialNumber,
        serial_number: e?.serialNumber,
        store_id: data?._id,
        business_id: data?.business_id,
        configuration: DefaultConfigurations,
        ...(getCookie('_type') === 'merchant' && { merchant_id: user?._id }),
      };
      try {
        await deviceService.createDevice(payload);
        Toast({
          message: 'Device Created Successfully',
          type: 'success',
        });
        refetch();
        onSubmit();
        onClose();
      } catch (error) {
        Toast({
          type: 'error',
          message: error?.message,
        });
      } finally {
        setLoading(false);
      }
    }
  }

  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        deviceName: data?.title,
        serialNumber: data?.serial_number,
      });
    }
  }, [isEdit, form, data]);

  return (
    <>
      <AddDeviceModalWrapper>
        <Form form={form} onSubmit={handelSubmit}>
          <div className="input-wrap">
            <Form.Item
              type="text"
              name="deviceName"
              sm
              rounded
              placeholder="Enter Device Name"
              label="Device Name"
              rules={[
                {
                  required: true,
                  message: 'Device Name is Required',
                },
              ]}>
              <Field maxLength={40} />
            </Form.Item>

            <Form.Item
              disabled={isEdit}
              type="number"
              name="serialNumber"
              sm
              rounded
              placeholder="Enter Serial Number"
              label="Serial Number"
              rules={[
                {
                  required: true,
                  message: 'Serial Number is Required',
                },
              ]}>
              <Field />
            </Form.Item>
          </div>

          <div>
            <Button width="184px" loader={loading}>
              {isEdit ? 'Update Device' : 'Add Device'}
            </Button>
          </div>
        </Form>
      </AddDeviceModalWrapper>
    </>
  );
};

export default AddDeviceModal;
